import React, { FC, Fragment } from 'react';
import { Formik } from 'formik';
import { Box, Grid } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import { ClientPublicFragment } from 'api/public';
import { sharingSchema } from '../../validations';
import { Share } from '../../types';

import useInitialShareValues from '../../useInitialValues';
import PartnerSharePreview from './Preview';
import PartnerShareFooter from './Footer';
import PartnerShareConnections from './Connections';

interface Props {
  partnerName: string;
  client: ClientPublicFragment;
  onSubmit: (values: Share) => void;
}

const useStyles = makeStyles({
  '@global body': {
    backgroundColor: '#FBFBFB',
  },
});

const PartnerShareIndex: FC<Props> = ({ partnerName, onSubmit }) => {
  useStyles();

  const initialValues = useInitialShareValues({ disablePages: true });
  const theme = useTheme();

  return (
    <Formik
      enableReinitialize
      validateOnMount
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={sharingSchema}
    >
      <Fragment>
        <Box padding={2}>
          <Grid container direction="column" spacing={3}>
            <Grid item>
              <Box bgcolor={theme.palette.common.white}>
                <PartnerSharePreview />
              </Box>
            </Grid>
            <PartnerShareConnections partnerName={partnerName} />
          </Grid>
        </Box>
        <PartnerShareFooter />
      </Fragment>
    </Formik>
  );
};

export default PartnerShareIndex;
